import { DmpChatAgentForm } from '@/features/dmp-chat/components/DmpChatAgentForm'
import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { useNavigate } from 'react-router'
import { AgentStudioBreadcrumbs } from '../AgentStudioBreadcrumbs'

export const AgentStudioNewAgentPage = () => {
  const navigate = useNavigate()

  return (
    <>
      <AgentStudioBreadcrumbs title="Agents" agentName="New agent" />
      <SectionLayout>
        <DmpChatAgentForm
          layout="grid"
          onSubmit={(agent) => {
            if (agent.id !== undefined && agent.id !== null) {
              navigate(`/agent-studio/agents/${agent.id}`)
              return
            }

            navigate('/agent-studio/agents')
          }}
        />
      </SectionLayout>
    </>
  )
}
